var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "680",
      maxWidth: "680",
      title: _vm.$t("label_essweb_shift_form_dialog_copyFromAnotherShift"),
      dialog: _vm.show,
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_shift_form_dialog_shiftNameLabel",
                            items: _vm.ShiftList,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "item-text": "shift_name",
                            "item-value": "uuid",
                          },
                          model: {
                            value: _vm.curShiftuuid,
                            callback: function ($$v) {
                              _vm.curShiftuuid = $$v
                            },
                            expression: "curShiftuuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _vm.SiteList.length
                          ? _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "max-width grey lighten-3 pa-6 rounded-lg",
                              },
                              _vm._l(_vm.SiteList, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "max-width rounded-lg mt-3",
                                    style: {
                                      overflow: "hidden",
                                      border:
                                        "1px solid var(--main-border-color)",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "\n                  text-subtitle-2 text--secondary\n                  pl-2\n                  pa-3\n                  text-capitalize\n                ",
                                        staticStyle: {
                                          "border-bottom":
                                            "1px solid var(--main-border-color)",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                item.site_name
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm._l(item.items, function (it, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticClass:
                                            "\n                  max-width\n                  text--primary\n                  pa-3\n                  d-flex\n                  flex-row\n                  justify-space-between\n                ",
                                          style: {
                                            borderBottom:
                                              i == item.items.length - 1
                                                ? "none"
                                                : "1px solid var(--main-border-color)",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "33.33333%",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      it.criteriaType
                                                        .criteria_type_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          it.criteria != null
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "33.33333%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          it.criteriaType
                                                            .punch_code == "GPS"
                                                            ? it.criteria
                                                                .criteria_gps_name
                                                            : it.criteriaType
                                                                .punch_code ==
                                                              "FACE"
                                                            ? it.criteria
                                                                .criteria_facial_name
                                                            : it.criteriaType
                                                                .punch_code ==
                                                              "WIFI"
                                                            ? it.criteria
                                                                .criteria_wifi_name
                                                            : it.criteriaType
                                                                .punch_code ==
                                                              "BLUETOOTH"
                                                            ? it.criteria
                                                                .criteria_bluetooth_name
                                                            : ""
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-capitalize",
                                                  staticStyle: {
                                                    width: "33.33333%",
                                                  },
                                                },
                                                [_vm._v(" Null ")]
                                              ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.newProperty, cancel: _vm.closePorpertyDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }